/*
 * @Author: Chao Yang
 * @Date: 2021-04-23 09:41:58
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-12-02 11:10:15
 */
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { FundTransactionProxy } from '../../proxy';

@Injectable()
export class FundTransactionService {
    constructor(private proxy: FundTransactionProxy) {

    }

    GetInvestorTransactions(dealId: number, mcpId: number, startTime: Date, endTime: Date) {
        return this.proxy.GetInvestorTransactions(dealId, mcpId, startTime, endTime).pipe(map(r => {
          r.value.forEach(t => {
            t.effectiveDate = new Date(t.effectiveDate);
          });
          return r;
        }));
    }

    GetDealTransactionColumns(dealId: number) {
        return this.proxy.GetDealTransactionColumns(dealId);
    }
}
